export const type = {
  anualList: '[Protesis Iniciado Autorizado Anual] anualList',
  mensualList: '[Protesis Iniciado Autorizado Mensual] mensualList',
};
